export const fonts = {
  body: "'DM Sans', sans-serif",
  heading: "'DM Sans', sans-serif",
  accent: "'Bricolage Grotesque', sans-serif",
}
